import { useOptionsContext, useSvgContext } from '../../context';

const ClipRect = ({ id, x, y, width, height }: any) => (
  <clipPath id={id}>
    <rect x={x} y={y - 2} width={width} height={height + 4} />
  </clipPath>
);

const Clipping = ({ children }: { children: React.ReactNode }) => {
  const { width, height, top, right, left, bottom } = useSvgContext();
  const { chartId } = useOptionsContext();
  return (
    <>
      <defs>
        <ClipRect
          id={chartId}
          x={left}
          y={top}
          width={width - right - left}
          height={height - top - bottom}
        />
      </defs>
      <g clipPath={`url(#${chartId})`}>{children}</g>
    </>
  );
};

export default Clipping;
